import React from "react"

import InstructionsSVG from "../../../assets/img/instructions_svg.svg"
import briefPdf from '../../../assets/pdf/DEHkaiTexni-small.pdf'
const Instructions = () => {
  return (
    <section className="container py-14 flex lg:flex-row flex-col justify-evenly items-center">
      <div className="bg-white p-8 rounded-lg max-w-[550px] mb-8 lg:mb-0">
        <h3 className="text-lg font-bold text-left text-secondary mb-4"> ΟΔΗΓΙΕΣ ΣΥΜΜΕΤΟΧΗΣ </h3>
        <p className="mb-4">Η υποβολή συμμετοχών ολοκληρώθηκε στις 10/9/2021. Μπορείτε να κατεβάσετε το brief με όλες τις πληροφορίες σχετικά με τον διαγωνισμό <a href={briefPdf} className="text-primary font-bold" download>εδώ.</a> <br/> </p>
        
        <a href={briefPdf} className="btn-primary mt-2 inline-block" download>
          Κατέβασε το brief
        </a>
      </div>
        <div>
            <img className="max-w-[300px] mx-auto" src={InstructionsSVG} alt="Instractions" />
        </div>

    </section>
  )
}

export default Instructions
